import React, { useEffect, useState } from 'react';
import { Alert, Col, Container, Dropdown, FormControl, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import DropdownMenu from 'react-bootstrap/esm/DropdownMenu';
import DropdownToggle from 'react-bootstrap/esm/DropdownToggle';
import '../../../../styles/Forms.css';

export function ProviderSection(props) {
    const [npi, setNpi] = useState(props.member.npi);
    const [stateLicense, setStateLicense] = useState(props.member.stateLicense);
    const [abbrTitle, setAbbrTitle] = useState(props.member.abbrTitle);
    const [specialty, setSpecialty] = useState(props.member.specialty);
    const [npiStat, setNpiStat] = useState("");
    const [npiComment, setNpiComment] = useState("");

    useEffect(() => {
        if (npi && npi.length === 10) {
            fetch('api/Registration/getMemberData/' + npi)
                .then((response) => {
                    response.json()
                        .then((json) => {
                            if (json.errors !== null && json.errors !== "") alert(json.errors)
                            let npiMember = json.message;
                            if ((props.member.firstName === "" || !props.member.firstName) && npiMember.firstName) props.member.firstName = npiMember.firstName;
                            if ((props.member.lastName === "" || !props.member.lastName) && npiMember.lastName) props.member.lastName = npiMember.lastName;
                            if ((props.member.stateLicense === "" || !props.member.stateLicense) && npiMember.stateLicense) setStateLicense(npiMember.stateLicense);
                            if ((abbrTitle === "" || !abbrTitle) && npiMember.abbrTitle) setAbbrTitle(npiMember.abbrTitle);
                            props.member.passStatus.npiPassStatus = npiMember.passStatus.npiPassStatus;
                            setNpiStat(npiMember.passStatus.npiPassStatus);
                            props.member.passStatus.npiComment = npiMember.passStatus.npiComment;
                            setNpiComment(npiMember.passStatus.npiComment);
                            setNpi(npi);
                        })
                        .catch((error) => {
                            console.log("json error: " + error);
                        })
                })
                .catch((error) => {
                    console.log("Response error: " + error);
                });
        }
    }, [npi]);

    useEffect(() => {
        props.member.npi = npi;
        props.member.stateLicense = stateLicense;
        props.member.abbrTitle = abbrTitle;
        props.member.specialty = specialty;
        props.member.passStatus.npiPassStatus = npiStat;
        props.member.passStatus.npiComment = npiComment;

        if (npi && npi.length === 10 && npiStat !== "FAIL" && stateLicense !== "" && stateLicense && abbrTitle !== "" && abbrTitle && specialty !== "" && specialty) {
            props.setProviderOkay();
        }
        else {
            props.setProviderNotOkay();
        }
    }, [npi, stateLicense, abbrTitle, specialty, npiStat, npiComment])

    const specialtyChanged = (value, added) => {
        var pos = specialtyIncluded(value);

        if (pos !== -1) added = false;
        if (added && (specialty === "" || !specialty)) setSpecialty(value);
        else if (added) setSpecialty(specialty + ";" + value);

        if (!added) {
            var split = specialty.split(";");
            if (pos !== -1) split.splice(pos, 1);

            setSpecialty(split.join(';'));
        }
    }

    const specialtyIncluded = (value) => {
        var split = (specialty) ? specialty.split(";") : "";

        for (var i = split.length - 1; i >= 0; i--) {
            if (split[i] === value) return i;
        }
        return -1;
    }

    return (
        <Container>
            <Row style={{ padding: "4px" }}>
                <Col className="d-flex justify-content-center" style={{ padding: "4px" }} >
                    <div className="d-flex justify-content-center">
                        <div style={{ paddingRight: "5px" }}>Provider NPI</div>
                        <FormControl
                            required={props.isProvider}
                            isInvalid={npi === null || npi.length < 10}
                            type="text"
                            placeholder="Provider NPI"
                            defaultValue={(npi && npi !== "") ? npi : undefined}
                            maxLength="10"
                            id="npi"
                            aria-label="npi"
                            aria-describedby="npi"
                            onChange={(e) => { setNpi(e.target.value); setNpiStat(""); setNpiComment(""); setNpi(e.target.value); }}
                            onKeyPress={(e) => { if (!(e.key >= "0" && e.key <= "9") || (e.keyCode === 8)) e.preventDefault() }}
                        />
                    </div>
                </Col>
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip id="legal-name-tip">
                        Please include any leading letters. Example formats: MD-1234, MD1234
                    </Tooltip>}
                >
                    <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                        <div className="justify-content-end" style={{ paddingRight: "5px" }}>State License Number</div>
                        <FormControl
                            required={props.isProvider}
                            isInvalid={stateLicense === null || stateLicense === ""}
                            className="justify-content-end"
                            type="text"
                            placeholder="State License Number"
                            defaultValue={(stateLicense && stateLicense !== "") ? stateLicense : undefined}
                            id="license"
                            name="license"
                            aria-label="license"
                            aria-describedby="license"
                            onChange={(e) => { setStateLicense(e.target.value) }}
                        />
                    </Col>
                </OverlayTrigger>
            </Row>
            {(npi !== "" && npiStat === "FAIL") ?
                <Row style={{ padding: "4px" }}>
                    <Col sm={2}></Col>
                    <Col className="d-flex justify-content-center" style={{ padding: "4px" }}>
                        <Alert variant="danger">{npiComment}
                        </Alert>
                    </Col>
                    <Col></Col>
                    <Col></Col>
                </Row> :
                <></>}
            <Row style={{ padding: "4px" }}>
                <Col sm={2} style={{ padding: "4px" }}></Col>
                <OverlayTrigger
                    placement="bottom"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip id="abbr-title-tip">Examples include: MD, APRN, ...</Tooltip>}
                >
                    <Col className="d-flex justify-content-center" style={{ padding: "4px" }}>
                        <div className="d-flex justify-content-center">
                            <div style={{ paddingRight: "5px" }}>Abbreviated Title</div>
                            <FormControl
                                required={props.isProvider}
                                isInvalid={abbrTitle === null || abbrTitle === ""}
                                type="text"
                                placeholder="Abbreviated Title"
                                defaultValue={(abbrTitle && abbrTitle !== "") ? abbrTitle : undefined}
                                id="abbr-title"
                                name="abbr-title"
                                aria-label="abbr-title"
                                aria-describedby="abbr-title"
                                maxLength="15"
                                onChange={(e) => { setAbbrTitle(e.target.value) }}
                            />
                        </div>
                    </Col>
                </OverlayTrigger>
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 400 }}
                    overlay={<Tooltip id="specialty-tip">Please select any that apply</Tooltip>}
                >
                    <Col className="d-flex justify-content-end" style={{ padding: "4px" }}>
                        <div style={{ paddingRight: "5px" }}>Provider Specialty</div>
                        <Dropdown
                            id="p-type-dropdown"
                            style={{ paddingLeft: "4px" }}
                        >
                            <DropdownToggle
                                className="table-button"
                                id="dropdown-specialty-button"
                                variant={(!specialty || specialty === "") ? "outline-danger" : "light"}
                                style={{ textAllign: "right", paddingBottom: "5" }}
                            >{(specialty && specialty !== "") ? specialty : "Provider Specialty"}</DropdownToggle>
                            <DropdownMenu
                                style={{ maxHeight: "200px", overflowY: "scroll" }}
                            >
                                {(props.specialtiesList !== null) ? props.specialtiesList.map((value, index) => (
                                    <Dropdown.Item
                                        key={index}
                                        eventKey={value}
                                        type="radio"
                                        value={value}
                                        active={specialtyIncluded(value) !== -1}
                                        onSelect={(e) => { specialtyChanged(e, true) }}
                                    >
                                        {value}
                                    </Dropdown.Item>
                                ))
                                    : <></>}
                            </DropdownMenu>
                        </Dropdown>
                    </Col>
                </OverlayTrigger>
            </Row>
        </Container>
    );
}